import { render, staticRenderFns } from "./Trasladosalidav.vue?vue&type=template&id=2657cf3a&"
import script from "./Trasladosalidav.vue?vue&type=script&lang=js&"
export * from "./Trasladosalidav.vue?vue&type=script&lang=js&"
import style0 from "./Trasladosalidav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports